import { useCallback, useEffect, useState } from 'react';
import { supabase } from './lib/supabase';
import { isOfficeHost } from './lib/roamingStorage';
import LoginPane from './components/LoginPane';
import CreateTaskPane from './components/CreateTaskPane';

export default function App() {
  const [email, setEmail] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const { data } = await supabase.auth.getSession();
    setEmail(data.session?.user?.email ?? null);
    setLoading(false);
  }, []);

  useEffect(() => {
    refresh();
    // Keep the pane in step with token refreshes and sign-out from elsewhere.
    const { data: sub } = supabase.auth.onAuthStateChange((_evt, session) => {
      setEmail(session?.user?.email ?? null);
    });
    return () => sub.subscription.unsubscribe();
  }, [refresh]);

  if (loading) return <div className="pane"><p className="muted">Loading…</p></div>;

  return (
    <>
      {email
        ? <CreateTaskPane email={email} onSignedOut={() => setEmail(null)} />
        : <LoginPane onSignedIn={refresh} />}
      {!isOfficeHost() && (
        <p className="dev-banner">
          Running outside Outlook — the session is in localStorage, not roaming settings.
        </p>
      )}
    </>
  );
}
